import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import useFetchCsrfToken from "../../0. Utilidades/useFetchCsrfToken";
import "../Maestra.css";

function MaestraInfoForm({ maestra, onSecUpdate }) {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const csrfToken = useFetchCsrfToken();

  if (!maestra) {
    return <div>Cargando...</div>;
  }

  const handleSecUpdate = async () => {
    setIsSubmitting(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/todas/${maestra.rut}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken, // Include CSRF token
          },
          credentials: "include", // Ensure credentials are sent
          body: JSON.stringify({ sec: !maestra.sec }),
        },
      );
      if (!response.ok) {
        throw new Error("Failed to update SEC certification");
      }
      onSecUpdate(); // Trigger a refresh after updating
      setShowModal(false);
    } catch (error) {
      console.error("Error updating SEC certification:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="maestra-info">
      <h5>Trayectoria</h5>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Nivel de Estudios:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.estudios ? maestra.estudios : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Certificado SEC:</strong>
        </div>
        <div
          className="maestra-info-data"
          onClick={() => setShowModal(true)}
          style={{ color: "blue", cursor: "pointer" }}
        >
          {maestra.sec ? "Sí" : "No"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Situación Laboral:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.s_laboral ? maestra.s_laboral : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Ingreso Promedio:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.ingresos ? maestra.ingresos : "-----"}
        </div>
      </div>
      <h5>Disponibilidad</h5>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>¿Puede trabajar en empresas?</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.disponibilidad ? maestra.disponibilidad : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>¿Dónde puede trabajar?</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.territorio ? maestra.territorio : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>¿Tiene licencia de conducir?</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.l_conducir ? maestra.l_conducir : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>¿Tiene movilización propia?</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.m_propia ? maestra.m_propia : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>¿Cómo la pueden contactar?</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.b_trabajo ? maestra.b_trabajo : "-----"}
        </div>
      </div>

      {/* Modal for SEC update confirmation */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Certificación SEC</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Segura quieres cambiar el estado de la certificación SEC de esta
          Maestra?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            disabled={isSubmitting}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleSecUpdate}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Procesando..." : "Confirmar"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MaestraInfoForm;
